import React from 'react';
import { useSelector } from 'react-redux';

const Statistics = () => {
  const matchData = useSelector((state) => state?.playersReducer?.matchData);
  return (
    <div className='w-full h-full'>

      <div className='w-full h-[2500px] '>
         <iframe
           className='w-full h-[2500px] '
           src={`${process.env.REACT_APP_WEB_URL}/statistics?eid=${matchData?.event_id}`}
           width='100%'
           height="2500"
           title={`Statistics for Event ID ${matchData?.event_id}`}
           style={{ border: 'none' }}
         ></iframe>
     </div>
    </div>
  );
};

export default Statistics;

